"use client";

import { PilotProgramPage } from "@/components/shared/pilot-program-page";

const requirements = [
  {
    title: "Engaged Faculty",
    description: "1-3 departments open to exploring and piloting new AI technologies."
  },
  {
    title: "Executive Support",
    description: "Involve a senior sponsor (e.g., President, Director of Teaching and Learning, CIO) to help define the pilot evaluation."
  },
  {
    title: "Clear Objectives",
    description: "Designed for institutions that want to enrich their teaching and learning in both in-class and online settings."
  },
  {
    title: "Feedback Loop",
    description: "Commitment to gathering and sharing student/faculty feedback throughout the pilot to include in the evaluation report."
  },
  {
    title: "Year-Long Evaluation",
    description: "Our 12-month pilot provides time to evaluate impact and make informed decisions about wider implementation."
  },
  {
    title: "Pilot Budget",
    description: "A modest pilot fee covers our year-long support, all integrations, and pilot evaluation study."
  }
];

export default function PilotProgram() {
  return (
    <PilotProgramPage
      variant="default"
      title={<>Join Our 2026-2027<br />Pilot Program</>}
      subtitle="Ready to close your teaching and learning loop? StudyStash delivers secure, AI-powered learning within institutional guardrails."
      caseStudyLink="/about/case-studies/university-of-birmingham"
      caseStudyImage="/uob_studystash.png"
      caseStudyAlt="University of Birmingham StudyStash Case Study"
      reportImage="/uob_studystash_right.png"
      reportAlt="University of Birmingham StudyStash Report"
      whyPilotTitle="Hear Why Institutions Pilot"
      institutionType="institution"
      requirements={requirements}
    />
  );
}